import "../../assets/Privacy/Privacy.scss";
import "./Delivery.scss";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { Helmet } from "react-helmet";
import crumbs from "../../icons/icons8-home.svg";
import forward_arrow from "../../icons/icons-forward-arrow.png";
import { Link } from "react-router-dom";

export default function paymentDelivery() {
    return (
        <div className="privacy">
            <Helmet>
                <meta
                    name="keywords"
                    content="Оплата та доставка, Санберрі Україна"
                />
                <title>Публічна оферта від компанії Санберрі Україна</title>
                <link rel="canonical" href="https://sun-ukr.com/oplata-ta-dostavka" />
                <meta
                    name="description"
                    content="Інформація, наведена на сайті, є довідковою. Оплата та доставка ТОВ «Санберрі Україна» міститься за посиланням: https://sun-ukr.com/oplata-ta-dostavka"
                ></meta>
            </Helmet>
            <Header />
            <div className="crumbs">
                <Link className="crumbs__link" to="/">
                    <img className="crumbs__logo" src={crumbs} alt="crumbs" />
                </Link>
                <img className="crumbs__arrow" src={forward_arrow} alt="forward-arrow" />
                <span className="crumbs__text">Оплата та доставка</span>
            </div>
            <div className="privacy__container">
                <h1 className="privacy__title">Оплата та доставка</h1>
                <div className="paymentDelivery__block">
                    <b><p className="paymentDelivery__headline">1. Доставка добрив та посівного матеріалу від Санберрі Україна 🚛🌿</p></b>
                    <p className="paymentDelivery__caption">
                        Компанія Санберрі Україна дбає про те, щоб ви отримували якісну продукцію швидко та безпечно. Ми організовуємо зручну та оперативну доставку мінеральних добрив, органо-мінеральних комплексів та посівного матеріалу по всій території України.
                    </p>
                    <b><p className="paymentDelivery__headline">2. Способи доставки</p></b>
                    <p className="paymentDelivery__caption">Ми співпрацюємо з провідними перевізниками:</p>
                    <p className="paymentDelivery__caption">
                        ✔️ «Нова Пошта»
                    </p>
                    <p className="paymentDelivery__caption">
                        ✔️ «Делівері»
                    </p>
                    <p className="paymentDelivery__caption">
                        ✔️ «САТ»
                    </p>
                    <p className="paymentDelivery__caption">
                        ✔️ «Міст Експрес»
                    </p>
                    <p className="paymentDelivery__caption">
                        🚛 Інші логістичні оператори за домовленістю
                    </p>
                    <p className="paymentDelivery__caption">
                        🚛 Для великих замовлень можливе відвантаження вантажними автомобілями напряму з нашого складу.
                    </p>
                    <p className="paymentDelivery__caption">
                        🚜 Доставка власним транспортом
                    </p>
                    <b><p className="paymentDelivery__headline">3. Терміни доставки</p></b>
                    <p className="paymentDelivery__caption">⏳ Стандартний термін доставки – 1-3 робочі дні, залежно від регіону.</p>
                    <p className="paymentDelivery__caption">⚡ Термінова доставка – за домовленістю, якщо товар потрібен максимально швидко.</p>
                    <b><p className="paymentDelivery__headline">4. Вартість доставки</p></b>
                    <p className="paymentDelivery__caption">💰 Вартість доставки розраховується індивідуально та залежить від:</p>
                    <p className="paymentDelivery__caption">✔️ Об'єму та ваги замовлення</p>
                    <p className="paymentDelivery__caption">✔️ Відстані до пункту призначення</p>
                    <p className="paymentDelivery__caption">✔️ Тарифів транспортної компанії</p>
                    <p className="paymentDelivery__caption">✔️ Тарифів транспортної компанії</p>
                    <p className="paymentDelivery__caption">🚛 Безкоштовна доставка можлива при великих обсягах замовлення – деталі уточнюйте у менеджера.</p>
                    <b><p className="paymentDelivery__headline">Як замовити доставку?</p></b>
                    <p className="paymentDelivery__caption">
                        📞 1. Оформіть замовлення – на сайті, телефоном або через месенджери.
                    </p>
                    <p className="paymentDelivery__caption">
                        📦 2. Узгодьте спосіб доставки – виберіть найзручніший варіант.
                    </p>
                    <p className="paymentDelivery__caption">
                        🚚 3. Отримайте товар – у відділенні транспортної компанії або безпосередньо на полі.
                    </p>
                    <b><p className="paymentDelivery__headline">💬 Залишилися запитання?</p></b >
                    <p className="paymentDelivery__caption">
                        Наші менеджери завжди готові допомогти! 📲 Зв’яжіться з нами для консультації та уточнення деталей доставки.
                    </p>
                    <b><p className="paymentDelivery__headline">🌱 Санберрі Україна – якість, швидкість та надійність у кожній доставці! 🚜</p></b>
                    <p className="paymentDelivery__caption">
                        Купуючи у нас, ви в будь-якому випадку заощаджуєте на своєму результаті. Купуючи у виробника або в наших Дистриб’юторів ви завжди купуєте оригінальне. Пам'ятайте - не купуйте товар “з рук” без документів, ви наражаєте себе на небезпеку придбати підробку. Телефонуйте, наш менеджер надасть максимальні роз'яснення з будь-якого вашого запитання!</p>
                </div >
            </div >
            <Footer />
        </div >
    );
}
